import React, { useState, useEffect } from 'react';
import ResponsiveDialog from './ResponsiveDialog';
import { Material, StringType } from '../types';
import CreateStringTypeForm from './CreateStringTypeForm';
import { updateStringType } from '../api';
import { Box, Typography } from '@mui/material';

interface Props {
  open: boolean;
  onClose: () => void;
  existing: StringType | null;
  onUpdated: () => void;
  readOnly?: boolean;
  setReadOnly?: (editMode: boolean) => void;

}

export default function EditStringTypeForm({ open, onClose, existing, onUpdated, readOnly, setReadOnly }: Props) {
  const [initialData, setInitialData] = useState<Omit<StringType, 'id'>>({
    brand: '',
    name: '',
    gauge: '',
    color: '',
    material: Material.POLYESTER,
    stiffness: undefined,
    spinPotential: undefined,
  });

  useEffect(() => {
    if (existing) {
      setInitialData({
        brand: existing.brand ?? '',
        name: existing.name,
        gauge: existing.gauge ?? '',
        color: existing.color ?? '',
        material: existing.material,
        stiffness: existing.stiffness,
        spinPotential: existing.spinPotential,
      });
    }
  }, [existing]);

  const handleSave = async (data: Omit<StringType, 'id'>) => {
    if (existing) {
      await updateStringType(existing.id, data);
      onUpdated();
      onClose();
    }
  };

  if (!existing) return null;

  return (

    <ResponsiveDialog open={open} onClose={onClose} maxWidth="sm">
      <Box p={2}>
        
        <Typography variant="h6" mb={2}>
        {readOnly ? 'String Type' : 'Edit String Type'}
        </Typography>
        <CreateStringTypeForm
          onSave={handleSave}
          onCancel={onClose}
          initialData={initialData}
          readOnly={readOnly}
          setReadOnly={setReadOnly}
        />
      </Box>
    </ResponsiveDialog>
  );
}